<template>
    <div>
        <el-page-header @back="goBack" content="注册用户"></el-page-header>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" style="margin-top:15px" class="user-search">
          <el-form-item label="查询：">
            <el-date-picker
              v-model="formInline.yearmonth"
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              type="month"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="支付渠道">
              <el-select v-model="formInline.paychannel">
                  <el-option label="全部支付渠道" value=""></el-option>
                  <el-option v-for="item in payData" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="类型">
              <el-select v-model="formInline.type" @change="selectChange">
                  <el-option label="看订单笔数" :value="1"></el-option>
                  <el-option label="看订单流水" :value="2"></el-option>
                  <el-option label="看平台总收益" :value="3"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="角色">
              <el-select v-model="formInline.userType" @change="userTypeChange">
                  <el-option label="全部角色" :value="0"></el-option>
                  <el-option label="经销商" :value="1"></el-option>
                  <el-option label="商家" :value="2"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="经销商" v-if="formInline.userType == 1">
              <el-select v-model="formInline.distributorid" >
                  <el-option v-for="item in StoreUserList" :key="item.id" :label="item.nickname" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="商家" v-if="formInline.userType == 2">
              <el-select v-model="formInline.storeid">
                  <el-option v-for="item in storeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <div
            class="echart"
            ref="mychart"
            id="mychart"
            :style="{ float: 'left', width: '100%', height: '400px' }"
        ></div>
        <h3>收益明细</h3>
        <!--列表-->
        <el-table size="small" :data="orderList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column  prop="id" label="订单编号" ></el-table-column>
          <el-table-column  prop="store_name" label="商家名称" ></el-table-column>
          <el-table-column  prop="distributor_name" label="经销商名称" ></el-table-column>
          <el-table-column  prop="created_at" label="用户下单时间" ></el-table-column>
          <el-table-column  prop="order_amount" label="用户下单金额" ></el-table-column>
          <el-table-column  prop="amount" label="用户实付金额" ></el-table-column>
          <el-table-column  prop="sumamount" label="经销商收益" ></el-table-column>
          <el-table-column  prop="store_amount" label="商家收益" ></el-table-column>
          <el-table-column  prop="sum_system_amount" label="平台收益" ></el-table-column>
          <el-table-column  prop="commission_amount" label="手续费收益" ></el-table-column>
          <el-table-column  prop="system_amount" label="平台分润收益" ></el-table-column>
          <el-table-column  prop="RoundingNum" label="舍位收益" ></el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import * as echarts from "echarts";
import { censusCount , payorderEchart , loadPayChannelList , getStoreUserList , storeUsers , payorderEchartDetail} from '../../api/userMG'
export default {
  data() {
    return {
      payData:[],
      listData:[],
      storeData:[],
      StoreUserList:[],
      orderList:[],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      loading:false,
      formInline:{
        yearmonth:'',
        paychannel:'',
        distributorid:'',
        storeid:"",
        userType:0,
        type:1
      },
      name: "张雪",
      xData: ["2020-02", "2020-03", "2020-04", "2020-05"], //横坐标数据
      yData: [30, 132, 80, 134] //纵坐标数据，与横坐标对应
    };
  },
  components: {
    Pagination
  },
  mounted() {
    this.loadPayChannelList()
    this.getTime();
    this.storeUsers()
    this.getStoreUserList()
  },
  methods: {
    getStoreUserList(){
      getStoreUserList({userType:1}).then(res=>{
          this.StoreUserList = res.storeUsers
      })
    },
    storeUsers(){
      storeUsers().then(res=>{
        this.storeData = res.data
      })
    },
    userTypeChange(){
      this.formInline.distributorid = ''
      this.formInline.storeid = ''
    },
    loadPayChannelList(){
      loadPayChannelList().then(res=>{
        this.payData = res.channels
      })
    },
    callFather(){

    },
    goBack(){
      window.history.back();
    },
    getTime(){
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth()+1;
      this.formInline.yearmonth = `${year}-${month}`
      this.initEcharts()
      this.payorderEchartDetail()
    },
    payorderEchartDetail(){
      payorderEchartDetail({
        pageSize:this.pageparm.pageSize,
        page:this.pageparm.currentPage,
        month:this.formInline.yearmonth,
        paychannel:this.formInline.paychannel,
        storeid:this.formInline.userType == 2?this.formInline.storeid:'',
        distributorid:this.formInline.userType == 1?this.formInline.distributorid:''
      }).then(res=>{
        for(let item of res.data.dataList){
          item.RoundingNum = Math.floor((item.sum_system_amount - item.commission_amount - item.system_amount)*100)/100
        }
        this.orderList = res.data.dataList
        this.pageparm.total = res.data.total
      })
    },
    search(){
        this.pageparm.currentPage = 1
        this.initEcharts()
        this.payorderEchartDetail()
    },
    initEcharts() {
      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        tooltip: {
          trigger: 'axis',
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            areaStyle: {
              color:"green",
              opacity: 0.3,
              origin:"start"
            }
          }
        ]
      };
      payorderEchart({
        month:this.formInline.yearmonth,
        paychannel:this.formInline.paychannel,
        storeid:this.formInline.userType == 2?this.formInline.storeid:'',
        distributorid:this.formInline.userType == 1?this.formInline.distributorid:''
      }).then(res=>{
        option.xAxis.data = res.data.days
        if(this.formInline.type == 1){
          option.series[0].data = res.data.orderNums
        }else if(this.formInline.type == 2){
          option.series[0].data = res.data.amountNums
        }else if(this.formInline.type == 3){
          option.series[0].data = res.data.systemAmountNums
        }
        
        const myChart = echarts.init(this.$refs.mychart);// 图标初始化
        myChart.setOption(option);// 渲染页面
        //随着屏幕大小调节图表
        // window.addEventListener("resize", () => {
        //   myChart.resize();
        // });
      })
      
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/echartsView/TableFeeIncome.vue